<template>
  <!-- v-if="(item.parentId === 0 || item.parentId === -3 || (item.parentId === -4 || item.id === -4))" -->
  <template v-for="(item, index) in children?.folder">
    <div
      :class="{
        'menu-item': dept === 0,
        'depth-item': dept > 0,
        selected1: selectedFavorite === item,
        over: dragFavorite?.isFolder && overFavorite === item,
      }"
      :style="{
        display: searchFolderList === null || searchFolderList.has(item) ? '' : 'none',
        'border-top': dragFavorite?.isFolder && overFavorite === item ? '2px solid #000000' : '0',
      }"
      :title="item.title"
      @click.stop="changeSelectedFavorite(item)"
      @dblclick.stop="handleFolder(item)"
      @contextmenu.prevent="showContextMenuSelected($event, item)"
      :draggable="
        // 편집 모드(item.isEdit)일 땐 드래그 금지
        !item.isEdit &&
        ((item.isAppFavorite && item.sequence === -99999) ||
        findRootFolder(item).title === '모든 제약사'
          ? false
          : true)
      "
      @dragstart.stop="dragStart($event, item)"
      @dragover.stop="dragOver($event, item)"
      @dragleave="dragLeave($event, item)"
      @drop.stop="drop($event, item)"
    >
      <button
        class="btn-tree-toggle"
        :class="{ active: openFolderIndexs.has(item.id) }"
        @click.stop="handleFolder(item)"
      >
        <icon-arrow-right
          v-if="item.children && item.children.folder && item.children.folder.length > 0"
        />
        <icon-arrow-right v-else style="visibility: hidden" />
      </button>

      <!-- 즐겨찾기 폴더 루트 -->
      <span class="folder-toggle" @click.stop="handleFolder(item)">
        <template v-if="item.title === $t('label.favorite_rootFolder_my_favorite')">
          <icon-blue-folder-open v-if="openFolderIndexs.has(item.id)" />
          <icon-blue-folder v-else />
        </template>

        <template v-else-if="dept === 0 && item.title === '모든 제약사'">
          <icon-blue-folder-open v-if="openFolderIndexs.has(item.id)" />
          <icon-blue-folder v-else />
        </template>

        <template v-else-if="dept === 0">
          <!-- 공유즐겨찾기 -->
          <icon-sharing-open v-if="openFolderIndexs.has(item.id)" />
          <icon-sharing v-else />
        </template>

        <template v-else>
          <icon-normal-folder-open v-if="openFolderIndexs.has(item.id)" />
          <icon-normal-folder v-else />
        </template>
      </span>

      <FavoriteInput
        v-if="item.isEdit"
        v-bind:favorite="item"
        :placeholder="$t('label.input_folder_name')"
      />
      <strong class="label" v-else-if="selectedFavorite === item">{{ item.title }}</strong>
      <span class="label" v-else>{{ item.title }}</span>

      <!-- 폴더 우측 : 버튼  -->
      <button
        class="btn-more"
        @click.stop="toggleFolderMore(item)"
        v-if="dept !== 0 && !isChildOfForbiddenFolder(item)"
      >
        <icon-more />
      </button>

      <div
        class="more-menu"
        v-if="contextMenu.isShow && contextMenu.item === item && dept != 0"
        @click.stop="toggleFolderMore(item)"
      >
        <ul>
          <li style="border-bottom: 1px solid #ddd" @click.stop="onClickAddModify(item)">
            <button>{{ $t("button.rename") }}</button>
            <!--이름바꾸기-->
          </li>
          <li @click.stop="deleteItemSelected(item)">
            <button class="btn-delete">{{ $t("button.delete") }}</button>
            <!--삭제-->
          </li>
        </ul>
      </div>
    </div>

    <div class="depth-list" v-if="openFolderIndexs.has(item.id)">
      <FavoriteTree
        v-if="openFolderIndexs.has(item.id)"
        v-bind:dept="dept + 1"
        v-bind:children="item.children"
        v-bind:selectedFavorite="selectedFavorite"
        @changeSelectedFavorite="changeSelectedFavorite"
      />
    </div>
  </template>
</template>

<script>
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";
import _ from "lodash";
import { useCommonStore } from "@/store/common";
import { useFavoritesStore } from "@/store/favorites.js";

// import { getUser } from "@/lib/loginService"; // getUser 함수 가져오기

import FavoriteTree from "@/containerss/FavoriteTree.vue";
import FavoriteInput from "@/containerss/FavoriteInput.vue";
import menuData from "@/data/menuData.js";
import IconFavorites from "@/components/icon/IconFavorites.vue";
import IconRefresh from "@/components/icon/IconRefresh.vue";
import IconFolderAdd from "@/components/icon/IconFolderAdd.vue";
import IconSearch from "@/components/icon/IconSearch.vue";
import IconInfo from "@/components/icon/IconInfo.vue";
import IconArrowRight from "@/components/icon/IconArrowRight.vue";
import IconDelete from "@/components/icon/IconDelete.vue";
import EmptyText from "@/components/EmptyText.vue";
import IconSharing from "@/components/icon/IconSharing.vue";
import IconSharingOpen from "@/components/icon/IconSharingOpen.vue";
import IconMore from "@/components/icon/IconMore.vue";
import IconBlueFolder from "@/components/icon/IconBlueFolder.vue";
import IconNormalFolder from "@/components/icon/IconNormalFolder.vue";
import IconNormalFolderOpen from "@/components/icon/IconNormalFolderOpen.vue";
import IconBlueFolderOpen from "@/components/icon/IconBlueFolderOpen.vue";
import IconResultFold from "@/components/icon/IconResultFold.vue";
import IconSearchDelete from "@/components/icon/IconSearchDelete.vue";

export default defineComponent({
  name: "FavoriteTree",
  emits: ["changeSelectedFavorite", "hideButtonGroup"],
  components: {
    FavoriteTree,
    FavoriteInput,
    IconSearchDelete,
    IconResultFold,
    IconBlueFolderOpen,
    IconNormalFolderOpen,
    IconNormalFolder,
    IconBlueFolder,
    IconMore,
    IconSharingOpen,
    IconSharing,
    EmptyText,
    IconDelete,
    IconArrowRight,
    IconInfo,
    IconSearch,
    IconFolderAdd,
    IconRefresh,
    IconFavorites,
  },

  props: {
    dept: {
      type: Number,
      required: false,
    },
    children: {
      type: [Array, Object],
      required: false,
    },
    selectedFavorite: {
      type: Object,
      default: false,
    },
  },

  setup(props, { emit }) {
    const { t } = useI18n();

    const commonStore = useCommonStore();
    const { isAlertDialogOpen, alertDialog } = storeToRefs(commonStore);
    const favoritesStore = useFavoritesStore();
    const {
      favoriteData,
      favoriteList,
      openFolderIndexs,
      dragFavorite,
      overFavorite,
      changedFavoriteList,
      removeFavoriteList,
      searchFolderList,
      contextMenu,
    } = storeToRefs(favoritesStore);

    const toggleFolderMore = (item) => {
      if (contextMenu.value?.item === item) {
        // 이미 열려있는 경우 클릭 시 닫기
        contextMenu.value = {
          isShow: false,
          position: { x: 0, y: 0 },
          item: null,
        };
      } else {
        // 다른 아이템 클릭 시 해당 메뉴 열기
        contextMenu.value = {
          isShow: true,
          position: { x: 0, y: 0 }, // 필요시 좌표 설정
          item: item,
        };
      }
      console.log("toggleBookmarkMore isFolderMore", isFolderMore.value);
      console.log("toggleBookmarkMore bookmarkId", item.id);
      console.log("toggleBookmarkMore bookmark.tempId", item.tempId);
    };

    const isFolderMore = ref(false);
    const isPreOpen = ref(true);

    onMounted(() => {
      window.addEventListener("mousedown", closeContextMenu);
    });

    const handleFolder = (folder) => {
      emit("hideButtonGroup");
      const id = folder.id;
      if (openFolderIndexs.value.has(id)) {
        openFolderIndexs.value.delete(id);
      } else {
        openFolderIndexs.value.add(id);
        if (searchFolderList.value) {
          folder.children?.folder?.forEach((f) => searchFolderList.value.add(f));
          folder.children?.favorite?.forEach((f) => searchFolderList.value.add(f));
        }
      }
    };

    const openNewTap = (favorite) => {
      const id = favorite.id;

      const url = `${window.location.origin}/Favorite?favoriteId=${id}`;
      window.open(url, "_blank");
    };

    const showContextMenuSelected = (event, favorite) => {
      emit("hideButtonGroup");
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

      const x = vw - event.clientX - 152;
      const y = Math.min(event.clientY, vh);

      contextMenu.value = {
        isShow: true,
        position: { x, y },
        item: favorite,
      };
    };

    const changeSelectedFavorite = (favorite) => {
      favoritesStore.hideContextMenuItem();
      emit("changeSelectedFavorite", favorite);
      emit("hideButtonGroup");
    };

    const getMenuName = (code) => {
      return menuData.find((menu) => menu.code === code)?.name ?? "Default";
    };

    const dragStart = (e, favorite) => {
      favoritesStore.hideContextMenuItem();
      emit("hideButtonGroup");
      dragFavorite.value = favorite;
    };

    const dragOver = (e, favorite) => {
      e.preventDefault();

      if (dragFavorite.value === favorite || overFavorite.value === favorite) return;

      if (
        dragFavorite.value.isFolder &&
        !favorite.isFolder &&
        favorite.parent.children.favorite.indexOf(favorite) !== 0
      )
        return;

      // ❌ 공유 즐겨찾기 바로 아래 App 즐겨찾기 자리에 드래그 금지
      // const root = findRootFolder(favorite);
      const parent = favorite.parent;

      if (
        parent?.title === "공유 즐겨찾기" &&
        parent?.children?.folder?.[0] === favorite &&
        favorite.title === "App 즐겨찾기"
      ) {
        return; // 드래그 오버 상태 자체도 무시
      }

      overFavorite.value = favorite;

      if (!dragFavorite.value.isFolder && favorite.isFolder) {
        const id = favorite.id;

        isPreOpen.value = openFolderIndexs.value.has(id);

        openFolderIndexs.value.add(id);
        if (searchFolderList.value) {
          favorite.children?.folder?.forEach((f) => searchFolderList.value.add(f));
          favorite.children?.favorite?.forEach((f) => searchFolderList.value.add(f));
        }
      }
    };
    const dragLeave = (e, folder) => {
      e.preventDefault();
      if (!dragFavorite.value.isFolder) {
        const id = folder.id;

        if (!isPreOpen.value) {
          openFolderIndexs.value.delete(id);
        }
      }

      // 드래그가 중단되면 라인을 제거
      if (dragFavorite.value?.isFolder && overFavorite.value === folder) {
        overFavorite.value = null; // 선택된 항목 초기화
      }
    };
    const drop = (e, favorite) => {
      e.preventDefault();
      if (dragFavorite.value === overFavorite.value) {
        overFavorite.value = null;
        dragFavorite.value = null;
        return;
      }
      const move = dragFavorite.value;
      const target = overFavorite.value;

      // 방어: 공유즐겨찾기 1번 자리에 App 이외 폴더 드롭 시도 차단
      const isSharedRoot = target?.parent?.title === "공유 즐겨찾기";
      const isFirstFolder = target?.parent?.children?.folder?.[0] === target;
      // const isTargetApp = target?.title === "App 즐겨찾기";
      const isMoveApp = move?.title === "App 즐겨찾기";

      if (isSharedRoot && isFirstFolder) {
        if (!isMoveApp || move !== target) {
          commonStore.openAlertDialog({
            message: t("message.favorites_unable_to_move"),
          });
          overFavorite.value = null;
          dragFavorite.value = null;
          return;
        }
      }

      // ✅ 추가: App 즐겨찾기 그 자체에 드롭도 방지 (자체에 드롭되는 경우)
      if (target?.title === "App 즐겨찾기" && target?.parent?.title === "공유 즐겨찾기") {
        if (!isMoveApp || move !== target) {
          commonStore.openAlertDialog({
            message: t("message.favorites_unable_to_move"),
          });
          overFavorite.value = null;
          dragFavorite.value = null;
          return;
        }
      }
      // 일반
      const type = move.isFolder ? "folder" : "favorite";

      // target.parent 또는 target.parent.children 이 null 인 경우 방지
      if (!target?.parent || !target.parent.children?.[type]) {
        commonStore.openAlertDialog({
          message: t("message.favorites_unable_to_move"),
        });

        overFavorite.value = null;
        dragFavorite.value = null;
        return;
      }

      if (target.children && target.children[type]) {
        // 0.중복 이름확인
        const sameFavorite = target.children[type].find((f) => f.title === move.title);

        if (
          move.parentId !== target.parentId &&
          sameFavorite &&
          ((sameFavorite.id === null && move.id === null) || sameFavorite.id !== move.id)
        ) {
          if (move.isFolder) {
            commonStore.openAlertDialog({
              message: t("message.favorites_folder_with_the_same_name_already_exists"),
              afterEvent: null,
              afterCancel: () => {
                overFavorite.value = null; // 드래그 상태 초기화
                dragFavorite.value = null; // 드래그 상태 초기화
              },
            });
          } else {
            commonStore.openAlertDialog({
              message: t("message.favorites_with_the_same_name_already_exists"),
              afterEvent: () => {
                copyFavorite(move, target); //복사 (폴더리스트에서 복사하면 무조건 복사임 )

                _.remove(target.children.favorite, sameFavorite); // 기존에 존재하는 중복 항목 삭제
                _.remove(changedFavoriteList.value, sameFavorite); // 변경 목록에서 기존에 존재하는 중복 항목 삭제
                removeFavoriteList.value.push(sameFavorite); // 삭제 목록에 추가

                overFavorite.value = null;
                dragFavorite.value = null;
              },
              afterCancel: () => {
                overFavorite.value = null;
                dragFavorite.value = null;
              },
            });
          }

          return;
        }
      }

      //1. 상위 폴더가 다른 경우 복사, 동일한 경우 이동
      const moveRootFolder = findRootFolder(move); // 최상위 폴더 찾기
      const targetRootFolder = findRootFolder(target);

      if (moveRootFolder.id !== targetRootFolder.id) {
        copyFavorite(move, target);
        console.log("moveRootFolder.id", moveRootFolder.id);
        console.log("targetRootFolder.id", targetRootFolder.id);
      } else {
        //2. 같은 상위 폴더일 경우 이동

        //부모(move)폴더가 자식(target)폴더로 이동하는지 체크
        moveChildrenIDList = [move.id];
        moveChildrenFolderIDList(move);
        if (moveChildrenIDList.includes(target.parent.id)) {
          commonStore.openAlertDialog({
            message: t("message.favorites_unable_to_move"),
          });
          overFavorite.value = null;
          dragFavorite.value = null;
          return;
        }

        // 즐겨찾기 -> 폴더
        if (!dragFavorite.value.isFolder && overFavorite.value.isFolder) {
          if (!target.children) {
            target.children = { folder: [], favorite: [] };
          }
          const sameFavorite = target.children.favorite.find((f) => f.title === move.title); // 대상(Target)이 폴더이므로 parent.children 이 아닌 children 에서 찾음
          let targetParentId = target.parentId;

          // target 이 폴더일 경우, 폴더아래로 들어가기 때문에 비교할 때
          // 즐겨찾기의 ParentId 와 폴더의 Id 와 비교해야함
          if (target.isFolder) targetParentId = target.id;

          if (
            move.parentId !== targetParentId &&
            sameFavorite &&
            ((sameFavorite.id === null && move.id === null) || sameFavorite.id !== move.id)
          ) {
            commonStore.openAlertDialog({
              message: t("message.favorites_with_the_same_name_already_exists"),
              afterEvent: () => {
                moveFavoriteInFolder(move, target);

                _.remove(target.children.favorite, sameFavorite); // 기존에 존재하는 중복 항목 삭제
                _.remove(changedFavoriteList.value, sameFavorite); // 변경 목록에서 기존에 존재하는 중복 항목 삭제
                removeFavoriteList.value.push(sameFavorite); // 삭제 목록에 추가

                overFavorite.value = null;
                dragFavorite.value = null;
              },
              afterCancel: () => {
                overFavorite.value = null;
                dragFavorite.value = null;
              },
            });
            return;
          }
          moveFavoriteInFolder(move, target);
          return;
        }

        // 일반
        const type = move.isFolder ? "folder" : "favorite";

        // // 폴더 -> 폴더, 즐겨찾기 -> 즐겨찾기
        // ✅ 최상위 폴더로의 드롭이면 취소
        if (!target.parent || target === targetRootFolder) {
          commonStore.openAlertDialog({
            message: t("message.favorites_unable_to_move"), // "이동할 수 없습니다."
          });

          overFavorite.value = null;
          dragFavorite.value = null;
          return;
        }

        const sameFavorite = target.parent.children[type].find((f) => f.title === move.title);

        if (
          move.parentId !== target.parentId &&
          sameFavorite &&
          ((sameFavorite.id === null && move.id === null) || sameFavorite.id !== move.id)
        ) {
          if (move.isFolder) {
            commonStore.openAlertDialog({
              message: t("message.favorites_folder_with_the_same_name_already_exists"),
              afterEvent: null,
              afterCancel: null,
            });
          } else {
            commonStore.openAlertDialog({
              message: t("message.favorites_with_the_same_name_already_exists"),
              afterEvent: () => {
                moveFavorite(move, target);
                _.remove(target.parent.children[type], sameFavorite);
                _.remove(changedFavoriteList.value, sameFavorite);

                removeFavoriteList.value.push(sameFavorite);

                overFavorite.value = null;
                dragFavorite.value = null;
              },
              afterCancel: () => {
                overFavorite.value = null;
                dragFavorite.value = null;
              },
            });
          }

          return;
        }
        moveFavorite(move, target);

        console.log("이동됨");
      }

      overFavorite.value = null;
      dragFavorite.value = null;

      console.log("drop 종료");
    }; //함수끝

    //부모(move)폴더의 자식폴더ID 목록 조회
    let moveChildrenIDList;
    const moveChildrenFolderIDList = (move) => {
      move.children?.folder.forEach((item) => {
        moveChildrenFolderIDList(item);
        moveChildrenIDList.push(item.id);
      });
    };

    const moveFavoriteInFolder = (move, parent) => {
      _.remove(move.parent.children.favorite, move);
      let targetIndex = parent.children.favorite.indexOf(parent);
      let targetSequence =
        parent.children.favorite.length === 0 ? 1 : _.last(parent.children.favorite).sequence + 1;
      // let targetSequence = parent.children.favorite.length === 0? 1 : parent.children.favorite.length + 1;
      if (targetIndex === -1) parent.children.favorite.push(move);
      else parent.children[type].splice(targetIndex, 0, move);

      move.parentId = parent.id;
      move.parent = parent;
      move.sequence = targetSequence;

      // 변경사항에 추가
      if (changedFavoriteList.value.indexOf(move) === -1) {
        changedFavoriteList.value.push(move);
      } else {
        // 이미 변경 리스트에 있을 경우
        _.remove(changedFavoriteList.value, move); // 삭제
        changedFavoriteList.value.push(move); // 재 추가
      }

      parent.children.favorite
        .filter((f) => f.sequence >= move.sequence)
        .forEach((f, i) => {
          if (f != move) {
            f.sequence = move.sequence + i - 1;
            if (changedFavoriteList.value.indexOf(f) === -1) changedFavoriteList.value.push(f);
          }
        });

      overFavorite.value = null;
      dragFavorite.value = null;
      isPreOpen.value = true;
    };

    const moveFavorite = (move, target) => {
      const type = move.isFolder ? "folder" : "favorite";
      _.remove(move.parent.children[type], move);
      let targetIndex = target.parent.children[type].indexOf(target);

      moveChildrenIDList = [move.id];
      moveChildrenFolderIDList(move);
      if (moveChildrenIDList.includes(target.parent.id)) {
        commonStore.openAlertDialog({
          message: t("message.favorites_unable_to_move"),
        });
        overFavorite.value = null;
        dragFavorite.value = null;
        return;
      }

      // 1. 이동하려는 순서(사이에 놓을 시 아래쪽이 Target)의 Sequence 를 불러온다
      let targetSequence =
        targetIndex === -1
          ? (_.last(target.parent.children[type])?.sequence ?? 0) + 1
          : target.sequence;
      if (targetIndex === -1) target.parent.children[type].push(move);
      else target.parent.children[type].splice(targetIndex, 0, move);

      // 2. 이동하려는 항목(move)의 순서를 이동하려는 순서(target)로 변경
      move.parentId = target.parent.id;
      move.parent = target.parent;
      move.sequence = targetSequence;

      if (changedFavoriteList.value.indexOf(move) === -1) {
        changedFavoriteList.value.push(move);
      } else {
        // 이미 변경 리스트에 있을 경우
        _.remove(changedFavoriteList.value, move); // 삭제
        changedFavoriteList.value.push(move); // 재 추가
      }

      // 3. target 내 move 보다 크거나 같은 순서의 항목은 모두 순서를 + i 해준다.
      target.parent.children[type]
        .filter((f) => f.sequence >= move.sequence)
        .forEach((f, i) => {
          if (f != move) {
            f.sequence = move.sequence + i;
            if (changedFavoriteList.value.indexOf(f) === -1) changedFavoriteList.value.push(f);
          }
        });

      overFavorite.value = null;
      dragFavorite.value = null;
    };

    const copyFavorite = (copy, target) => {
      const type = copy.isFolder ? "folder" : "favorite";
      // 1. copy 객체를 복사하여 새로운 객체를 생성 (id와 parentId를 새롭게 설정)
      const newCopy = {
        ...copy, // 기존 속성 복사
        // id: _.uniqueId('favorite_'), // 새로운 ID 생성
        id: -1,
        tempId: _.uniqueId(""), // 새로운 ID 할당 (유일한 ID를 생성)
        parentId: target.id, // 새로운 부모 ID 설정 (복사된 상위 폴더의 ID)
        sequence: 0, // 복사할 위치에 따라 순서가 결정됨
        children: copy.isFolder ? { folder: [], favorite: [] } : undefined, // 폴더일 경우 하위 폴더/즐겨찾기 초기화
        originalId: copy.id,
      };

      // 2. 타겟의 children 초기화가 되어 있는지 확인
      if (!target.children) {
        target.children = { folder: [], favorite: [] };
      }

      // 3. 복사한 객체를 타겟 위치에 추가
      let targetSequence =
        target.children[type].length > 0 ? (_.last(target.children[type])?.sequence ?? 0) + 1 : 1;

      target.children[type].push(newCopy);

      // 4. 복사된 항목의 parentId, parent, sequence를 설정
      newCopy.parent = target; // 새로운 부모를 설정
      newCopy.sequence = targetSequence;

      // 변경된 리스트에 복사된 항목 추가
      if (changedFavoriteList.value.indexOf(newCopy) === -1) {
        changedFavoriteList.value.push(newCopy);
      }

      // 5. 복사된 객체의 하위 폴더와 즐겨찾기들을 재귀적으로 복사
      if (copy.isFolder && copy.children) {
        // 하위 폴더가 있는지 확인하고 복사
        if (Array.isArray(copy.children.folder)) {
          copy.children.folder.forEach((childFolder) => {
            copyFavorite(childFolder, newCopy); // 재귀적 복사
          });
        }

        // 하위 즐겨찾기가 있는지 확인하고 복사
        if (Array.isArray(copy.children.favorite)) {
          copy.children.favorite.forEach((childFavorite) => {
            copyFavorite(childFavorite, newCopy); // 재귀적 복사
          });
        }
      }

      // 6. target 내 newCopy보다 크거나 같은 순서의 항목은 모두 순서를 + i 해준다.
      target.children[type]
        .filter((f) => f.sequence >= newCopy.sequence)
        .forEach((f, i) => {
          if (f !== newCopy) {
            f.sequence = newCopy.sequence + i;
            if (changedFavoriteList.value.indexOf(f) === -1) {
              changedFavoriteList.value.push(f);
            }
          }
        });

      console.log("즐겨찾기 복사됨");
      overFavorite.value = null;
      dragFavorite.value = null;
    };

    // 최상위 폴더 찾는 함수 (재귀적으로 부모를 찾음)
    const findRootFolder = (folder) => {
      let currentFolder = folder;
      // currentFolder의 부모가 있고, 그 부모의 부모가 있을 때까지 반복
      while (currentFolder.parent && currentFolder.parent.parent) {
        currentFolder = currentFolder.parent;
      }

      // console.log('findRootFolder 최상위폴더 = ' , currentFolder.title)
      return currentFolder;
    };

    // 해당 폴더가 값(기본:'모든 제약사') 의 하위 폴더인지 확인하는 함수
    const isChildOfForbiddenFolder = (item, title = "모든 제약사") => {
      let current = item;
      while (current) {
        if (current.title === title) {
          return true;
        }
        current = current.parent;
      }
      return false;
    };

    const deleteItemSelected = (favorite) => {
      const type = favorite.isFolder ? "folder" : "favorite";

      if (type == "folder") {
        isAlertDialogOpen.value = true;
        alertDialog.value = {
          maxWidthOption: "",
          title: "",
          message: t("message.favorites_folder_delete", {
            name: favorite.title,
          }),
          afterEvent: async () => {
            removeFavoriteList.value.push(favorite);

            _.remove(favorite.parent.children[type], favorite);
            _.remove(changedFavoriteList.value, favorite);

            contextMenu.value = {
              isShow: false,
              position: { x: 0, y: 0 },
              id: null,
              isFolder: false,
            };
          },
          afterCancel: () => {},
        };
      } else {
        isAlertDialogOpen.value = true;
        alertDialog.value = {
          maxWidthOption: "",
          title: "",
          message: t("message.favorites_delete", { name: favorite.title }),
          afterEvent: async () => {
            removeFavoriteList.value.push(favorite);

            _.remove(favorite.parent.children[type], favorite);
            _.remove(changedFavoriteList.value, favorite);
          },
          afterCancel: () => {},
        };
      }
    };

    const onClickAddModify = (favorite) => {
      favorite.isEdit = true;
      contextMenu.value = {
        isShow: false,
        position: { x: 0, y: 0 },
        id: null,
        isFolder: false,
      };
    };

    const closeContextMenu = (event) => {
      // contextMenu가 있는 DOM 요소를 가져옵니다.
      const contextMenuElement = document.querySelector(".more-menu");

      // 만약 이벤트가 contextMenu 내부에서 발생하지 않았다면 contextMenu를 닫습니다.
      if (contextMenuElement && !contextMenuElement.contains(event.target)) {
        contextMenu.value.isShow = false;
      }
    };

    return {
      favoriteData,
      favoriteList,
      openFolderIndexs,
      searchFolderList,

      handleFolder,
      openNewTap,
      showContextMenuSelected,
      changeSelectedFavorite,

      dragFavorite,
      overFavorite,
      dragStart,
      dragOver,
      dragLeave,
      drop,

      getMenuName,

      isFolderMore,
      toggleFolderMore,

      onClickAddModify,
      deleteItemSelected,

      findRootFolder,
      isChildOfForbiddenFolder,
      contextMenu,
    };
  },
});
</script>

<style scoped>
.favorites {
  display: flex;
  flex-direction: column;

  height: 100%;
  max-height: 100%;
}

.favorites-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  height: 41px;
  margin-bottom: 12px;
  padding: 20px 24px 32px;
}

.favorites-title .title {
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}

.favorites-title .title span {
  vertical-align: top;
}

.favorites-title .title span + span {
  margin-left: 5px;
}

.favorites-title .title .btn-refresh {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.favorites-title .title .btn-refresh i {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.favorites-header {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 0;
}

.favorites-header .flex-l {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.favorites-header .flex-l button {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  /* 157.143% */
  letter-spacing: -0.28px;
  padding: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 140px;
}

.favorites-header .flex-l button.btn-fold-add {
  color: #174fdc;
  border: 1px solid #174fdc;
}

.favorites-header .flex-l button.btn-favorite-add {
  color: #343434;
  border: 1px solid #dddddd;
}

.favorites-header .flex-l button i {
  margin-right: 4px;
}

.favorites-header .flex-l button.btn-favorite-add i {
  width: 18px !important;
}

.favorites-header .search-wrap {
  position: relative;
}

.favorites-header .search-wrap input {
  padding-right: 38px;
}

.favorites-header .search-wrap input:focus {
  border: 1px solid #222222;
}

.favorites-header .search-wrap .btn-search {
  width: 20px;
  height: 20px;
  position: absolute;
  display: block;
  right: 14px;
  top: 5px;
}

.favorites-header .search-wrap .btn-search-delete {
  width: 20px;
  height: 20px;
  position: absolute;
  display: block;
  right: 12px;
  top: 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.favorites-header .btn-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.favorites-header .btn-group .btn.unfold {
  display: flex;
  align-items: center;
  padding: 0 8px 0 12px;
  border-radius: 28px;
  overflow: hidden;
}

.favorites-header .btn-group .btn.unfold span {
  font-size: 16px;
  color: #b8b8b8;
  margin-left: 8px;
}

.favorites-header .btn,
.favorites-header .search-group > input {
  height: 28px;
}

.favorites-header .btn-group .btn2 {
  height: 24px;
  width: 24px;
  padding: 3px;
}

.favorites-header .btn-group .btn2:disabled {
  background-color: #ebebeb;
}

.me-search {
  position: absolute;
  width: 810px;
  margin-top: 10px;
  padding: 10px 15px 10px 15px;
  z-index: 1;
}

.aside-collapsed {
  position: absolute;
  border: var(--border-line);
  background-color: #fff;
  box-shadow: -4px 6px 12px rgba(6, 10, 19, 0.2);
}

.me-title {
  display: flex;
  align-items: center;
  margin: 20px 0 10px;
}

.me-title h4 {
  font-size: 16px;
  font-weight: 700;
  margin-right: 10px;
}

.me-tab {
  display: flex;
}

.me-tab > div {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  padding: 3px 0;
  background-color: #fff;
  border: var(--border-line);
  border-left-width: 0;
  font-size: 13px;
  font-weight: 500;
  /* 20230619 추가 */
  cursor: pointer;
  text-align: center;
  transition: all 0.1s ease-in;
}

.me-tab > div:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-left-width: 1px;
}

.me-tab > div:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.me-tab > div:hover {
  background-color: #f5f5f5;
}

.me-tab > div.active,
.me-tab > div.active:hover {
  border-color: var(--primary-color);
  background-color: var(--primary-color);
  color: #fff;
}

.favorites-body {
  flex: 1 1 auto;
  overflow-y: hidden;
}

.favorites-body2 {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 180px;
}

.favorites-body2 h1 {
  padding-top: 16px;
  padding-bottom: 8px;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  color: #333;
}

.favorites-body2 h2 {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #666;
}

.me-loading {
  position: relative;
  height: 100%;
  width: 100%;

  background-color: #fff;
}

.me-table {
  overflow: visible;
  height: 91%;
}

.me-table .tit {
  position: relative;
  display: inline-block;
  font-size: 15px;
  font-weight: 700;
  padding-left: 12px;
}

.me-table .tit::before {
  position: absolute;
  left: 0;
  top: 50%;
  content: "";
  width: 5px;
  height: 5px;
  background-color: #ccc;
  border-radius: 50%;
  transform: translateY(-50%);
}

.me-table table {
  border-top: 2px solid #000;
  border-bottom: 1px solid #e9e9e9;
  font-size: 13px;
  line-height: 1.4;
}

.me-table table th {
  text-align: center;
  vertical-align: middle;
  font-weight: 500;
  color: #000;
  background-color: #f5f5f5;
  padding: 7px 20px;
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
}

.me-table table td {
  vertical-align: middle;
  padding: 7px 20px;
  border-top: 1px solid #e9e9e9;
  white-space: normal;
  color: var(--font-sec-color);
}

.search-content {
  display: flex;
  flex: 1 1 auto;
  min-height: 150px;
}

.search-content-sub {
  flex: 1 1 auto;
  width: 100%;
}

.search-content-sub + .search-content-sub {
  margin-left: 5px;
}

.selected {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.selected .header {
  display: flex;
  align-items: center;
  height: fit-content;
  padding: 4px 16px;
  background-color: #f5f5f5;
  border: var(--border-line);
  border-bottom: 0;
  font-size: 15px;
  font-weight: 700;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;

  /* 목록 펼치고 접기 0623 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selected .header > span {
  display: inline-block;
  margin-left: 4px;
}

.selected .header > span.material-symbols-outlined {
  font-size: 26px;
  color: #b9b9b9;
}

.selected select {
  flex: 1 1 auto;
  max-width: 100%;
  width: 100%;
  padding: 12px;
  border: var(--border-line);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.selected select:focus {
  /* border: 1px solid #999; */
  outline: none;
}

.selected select option {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  padding: 4px 6px;
  margin: 1px 0;
}

.selected select option:checked {
  border-radius: 4px;
  background: #e1e8f6 linear-gradient(0deg, #e1e8f6 0%, #e1e8f6 100%);
}
</style>
